module.exports = __webpack_public_path__ + "img/middle.9579780b.jpg";